(ns app.front.view.property.v2.data-header
  (:require [app.front.ui.content-switcher :as ui-cs]
            [app.front.view.attachment.list :as attachment-list]
            [app.front.view.property.subs :as property-subs]
            [app.front.view.property.v2.additional-addresses-section :as additional-addresses-section]
            [app.front.view.property.v2.map-section :as map-section]
            [app.front.view.property.v2.relations-section :as relations-section]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]))

(defn data-tabs [relations-enabled?
                 attachments-enabled?
                 can-edit?
                 authority?
                 property-management-group?
                 property-db-units?
                 multiple-addresses?]
  (cond-> (if property-db-units?
            [:property-view/location-and-units-tab
             :property-view/attributes-tab]
            [:property-view/attributes-tab])
    (and attachments-enabled?
         property-management-group?
         (or can-edit? authority?))
    (conj :property-view/attachments-tab)
    relations-enabled?
    (conj :property-view/property-relations-tab)
    (not property-db-units?)
    (conj :property-view/location-map-tab)
    multiple-addresses?
    (conj :property-view/additional-addresses-tab)))

(defn data-header [{:keys [tr content property]}]
  (let [current-tab                   (<sub [::property-subs/selected-property-data-tab])
        property-relations-enabled?   (<sub [::ff/enabled? :feature-flag.id/property-relations-view])
        property-attachments-enabled? (<sub [::ff/enabled? :feature-flag.id/property-attachments])
        property-db-units?            (<sub [::ff/enabled? :feature-flag.id/property-db-units])
        multiple-addresses?           (<sub [::ff/enabled? :feature-flag.id/property-multiple-addresses])
        can-edit?                     (<sub [::property-subs/can-edit?])
        property-authority?           (<sub [::property-subs/property-authority?])
        has-relations?                (seq (<sub [::property-subs/property-relations]))
        property-management?          (<sub [::property-subs/property-management-group?])
        can-modify-relations?         (relations-section/can-modify-relations? property)
        relations-tab-visible?        (and property-relations-enabled?
                                           (or has-relations? can-modify-relations?))
        tabs                          (data-tabs relations-tab-visible?
                                                 property-attachments-enabled?
                                                 can-edit?
                                                 property-authority?
                                                 property-management?
                                                 property-db-units?
                                                 multiple-addresses?)]
    [:div
     [:div.mb-4
      [ui-cs/content-switcher
       {:items     tabs
        :val->str  (comp tr vector)
        :current   current-tab
        :on-change #(>evt [::property-subs/set-selected-property-data-tab %])}]]
     [:div
      (case current-tab
        :property-view/attributes-tab
        content

        :property-view/attachments-tab
        [attachment-list/list-view {:target property}]

        :property-view/property-relations-tab
        [relations-section/relations-section {:tr tr :property property}]

        :property-view/additional-addresses-tab
        [additional-addresses-section/additional-addresses-section {:tr tr :property property}]

        (:property-view/location-and-units-tab :property-view/location-map-tab)
        [map-section/map-section {:tr tr :property property}]

        content)]]))
